import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "appointment_prices",
    object: "appointment_price",
    header: [
      { text: "Descripción", value: "description" },
      { text: "Precio ARS", value: "price_ars" },
      { text: "Precio USD", value: "price_usd" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
